import { render, staticRenderFns } from "./DyorLogo.vue?vue&type=template&id=44a0cd92&scoped=true"
import script from "./DyorLogo.vue?vue&type=script&lang=js"
export * from "./DyorLogo.vue?vue&type=script&lang=js"
import style0 from "./DyorLogo.vue?vue&type=style&index=0&id=44a0cd92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0cd92",
  null
  
)

export default component.exports